import { useState } from "react"

export const NotifState = () => {
    const [openNotif, setOpenNotif] = useState(!("Notification" in window) ? false:true)
    const [allowNotif, setAllowNotif] = useState(false)
    const [notif, setNotif] = useState({all: { all: [], read: [] }, unread: []});

    // New state
    const [notification, setNotification] = useState({
        toggled: false,
        list: [],
        menu: {
            toggled: false
        }
    })
   
    return {
        openNotif: {data: openNotif, set: setOpenNotif},
        allowNotif: {data: allowNotif, set: setAllowNotif},
        notif: {data: notif, set: setNotif},
        
        // New state
        notification:  {data: notification, set: setNotification}
    }
}